<template>
    <div>
        <div v-if="courseAbsenceList && courseAbsenceList.length">
            <b-table :empty-text="this.$t('there_are_no_records')"  bordered striped responsive :items="absenceItems"
                :fields="absenceFields" show-empty class="mb-5 table-dropdown no-scrollbar border rounded">
            </b-table>
        </div>
    </div>
</template>
<script>

import moment from "moment";

export default {
    name: "AttendanceDetailTable",
    props: {
        courseAbsenceList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            absenceItems: [],
            absenceFields: [
                {
                    key: 'date',
                    label: this.$t('date'),
                    tdClass: 'w-50 text-center',
                    thClass: 'd-flex justify-content-center align-center',
                },
                {
                    key: 'hours',
                    label: this.$t('attendance_hours'),
                    tdClass: 'w-50 text-center',
                    thClass: 'text-center'
                },
            ]
        }
    },
    watch: {
        courseAbsenceList: {
            handler(value) {
                this.setAbsenceData(value)
            }
        }
    },
    methods: {
        setAbsenceData(value) {
            this.absenceItems = (value || []).map(itm => ({
                date: itm.date ? moment(itm.date, 'YYYY-MM-DD').format('DD-MM-YYYY') : itm.date,
                hours: itm.hours || itm.hours || '-'
            }))
        }
    }
}
</script>
